import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {User} from './models';
import {AuthenticationService} from './services/authentication/authentication.service';
import {Role} from './models/roles';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {filter, map} from 'rxjs/operators';
import {UTMService} from './services/authentication/utm.service';
import {isPlatformBrowser} from '@angular/common';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'argon-dashboard-angular';
  currentUser: User;

  constructor(
    public router: Router,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private utmService: UTMService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && !event.urlAfterRedirects.includes('admin')) {
        if (isPlatformBrowser(this.platformId)) {
          gtag('config', 'UA-153448449-1',
            {
              'page_path': event.urlAfterRedirects
            }
          );
        }
      }
    });

    const appTitle = this.titleService.getTitle();


    this.activatedRoute.queryParams.subscribe(v => {
      if (v.utm_content !== undefined) {
        utmService.setContent = (v.utm_content);
      }
      if (v.utm_medium !== undefined) {
        utmService.setMedium = (v.utm_medium);
      }
      if (v.utm_source !== undefined) {
        utmService.setSource = (v.utm_source);
      }
      if (v.utm_campaign !== undefined) {
        utmService.setCampaign = (v.utm_campaign);
      }
    });


    this.router
      .events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        const child1 = this.activatedRoute.firstChild;

        if (child1) {
          const child2 = child1.firstChild;
          if (child2) {
            const child3 = child2.firstChild;
            if (child3) {
              if (child3.snapshot.data['title']) {
                return child3.snapshot.data['title'];
              }
            }
            if (child2.snapshot.data['title']) {
              return child2.snapshot.data['title'];
            }
          }
          if (child1.snapshot.data['title']) {
            return child1.snapshot.data['title'];
          }

        }


        return appTitle;
      })
    ).subscribe((ttl: string) => {
      this.titleService.setTitle(ttl);
    });
  }


  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
